import { useState } from "react";
import axios from "axios";

function useAddPlayer() {
  const [loading, setLoading] = useState(false);

  const addPlayer = async (playerData) => {
    console.log('entorno', process.env.NODE_ENV);
    try {
      setLoading(true);
      const BEARER_TOKEN = "Bearer " + window.localStorage.getItem("jwt");
      const ADD_PLAYER_URL =
        process.env.NODE_ENV !== "production"
          ? process.env.REACT_APP_URL_API_LOCAL + "/players"
          : process.env.REACT_APP_URL_API + "/players";
      const playerResponse = await axios.post(ADD_PLAYER_URL, playerData, {
        headers: { Authorization: BEARER_TOKEN },
      });

      return true;
    } catch (e) {
      console.log(e?.response?.message);
      return "Error al registrar";
    } finally {
      setLoading(false);
    }
  };

  return { loading, addPlayer };
}

export default useAddPlayer;
